export const customerInvoicesCols = [{
    headerClassName: 'data-table header fixedNumber-xxl',
    className: 'fixedNumber-xxl',
    show: true,
    accessor: 'internalInvoiceNumber',
    isActionLink: true,
    id: 'sapInvoiceNumber-col-link',
    fieldHeader: 'Internal Invoice Number',
    sortable: true
},
{
    headerClassName: 'data-table header fixedNumber',
    className: 'fixedNumber',
    show: true,
    accessor: 'sapInvoiceNumber',
    isActionLink: false,
    id: 'sapInvoiceNumber-col',
    fieldHeader: 'SAP Invoice Number',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'status',
    id: 'status-col',
    fieldHeader: 'Invoice Status',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'category',
    id: 'category-col',
    fieldHeader: 'Category',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'invoiceType',
    id: 'type-col',
    fieldHeader: 'Invoice Type',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'billToParty',
    id: 'billToParty-col',
    fieldHeader: 'Bill-to-party',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'icbIndicator',
    id: 'icbIndicator-col',
    fieldHeader: 'ICB Indicator',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'createdDate',
    id: 'invoiceCreateDate-col',
    fieldHeader: 'Invoice Create Date',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'createdBy',
    id: 'invoiceCreated-col',
    fieldHeader: 'Invoice Created By',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'id',
    id: 'id-col',
    fieldHeader: 'ID',
    sortable: true
}]